var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 110,
    viewBox: "0 0 120 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.833 22.7725H19.0352C17.9306 22.7725 17.0352 23.6679 17.0352 24.7725V87.5573C17.0352 88.6619 17.9306 89.5573 19.0352 89.5573H116.833C117.938 89.5573 118.833 88.6619 118.833 87.5573V24.7725C118.833 23.6679 117.938 22.7725 116.833 22.7725Z",
    fill: "#D4DBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.643 31.2178H19.3066V87.4212H116.643V31.2178Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.384 31.0723H19.2988V87.6596H117.384V31.0723Z",
    fill: "#D4DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.892 19H21.0352C18.826 19 17.0352 20.7909 17.0352 23V31.8265H118.892V23C118.892 20.7909 117.102 19 114.892 19Z",
    fill: "#D4DBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3708 31.8262H19.2988V42.3891H31.3708V31.8262Z",
    fill: "#7E49DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.197 31.8262H32.125V42.3891H44.197V31.8262Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2686 31.8262H44.9512V42.3891H56.2686V31.8262Z",
    fill: "#F2F4FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5884 31.8262H57.0254V42.3891H67.5884V31.8262Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6573 31.8262H68.3398V42.3891H79.6573V31.8262Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9751 31.8262H80.4121V42.3891H90.9751V31.8262Z",
    fill: "#F2F4FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 31.8262H91.7305V42.3891H104.557V31.8262Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.63 31.8262H105.312V42.3891H116.63V31.8262Z",
    fill: "#7E49DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3708 43.1436H19.2988V53.7065H31.3708V43.1436Z",
    fill: "#F2F4FE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.197 43.1436H32.125V53.7065H44.197V43.1436Z",
    fill: "#F2F4FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2686 43.1436H44.9512V53.7065H56.2686V43.1436Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5884 43.1436H57.0254V53.7065H67.5884V43.1436Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6573 43.1436H68.3398V53.7065H79.6573V43.1436Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9751 43.1436H80.4121V53.7065H90.9751V43.1436Z",
    fill: "#7E49DD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 43.1436H91.7305V53.7065H104.557V43.1436Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.63 43.1436H105.312V53.7065H116.63V43.1436Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3708 54.4619H19.2988V65.7794H31.3708V54.4619Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.197 54.4619H32.125V65.7794H44.197V54.4619Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2686 54.4619H44.9512V65.7794H56.2686V54.4619Z",
    fill: "#7E49DD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5884 54.4619H57.0254V65.7794H67.5884V54.4619Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6573 54.4619H68.3398V65.7794H79.6573V54.4619Z",
    fill: "#F2F4FE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9751 54.4619H80.4121V65.7794H90.9751V54.4619Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 54.4619H91.7305V65.7794H104.557V54.4619Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.63 54.4619H105.312V65.7794H116.63V54.4619Z",
    fill: "#7E49DD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3708 66.5332H19.2988V76.3417H31.3708V66.5332Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.197 66.5332H32.125V76.3417H44.197V66.5332Z",
    fill: "#6020D4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2686 66.5332H44.9512V76.3417H56.2686V66.5332Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5884 66.5332H57.0254V76.3417H67.5884V66.5332Z",
    fill: "#7E49DD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6573 66.5332H68.3398V76.3417H79.6573V66.5332Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.9751 66.5332H80.4121V76.3417H90.9751V66.5332Z",
    fill: "#F2F4FE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 66.5332H91.7305V76.3417H104.557V66.5332Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M116.63 66.5332H105.312V76.3417H116.63V66.5332Z",
    fill: "#7E49DD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.3708 77.0967H19.2988V87.6597H31.3708V77.0967Z",
    fill: "#6020D4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.197 77.0967H32.125V87.6597H44.197V77.0967Z",
    fill: "#6020D4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2686 77.0967H44.9512V87.6597H56.2686V77.0967Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5884 77.0967H57.0254V87.6597H67.5884V77.0967Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6573 77.0967H68.3398V87.6597H79.6573V77.0967Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9751 77.0967H80.4121V87.6597H90.9751V77.0967Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 77.0967H91.7305V87.6597H104.557V77.0967Z",
    fill: "#7E49DD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.63 77.0967H105.312V87.6597H116.63V77.0967Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1214 106.999C35.891 106.999 46.2428 96.5971 46.2428 83.7653C46.2428 70.9335 35.891 60.5312 23.1214 60.5312C10.3518 60.5312 0 70.9335 0 83.7653C0 96.5971 10.3518 106.999 23.1214 106.999Z",
    fill: "#6020D4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1217 102.642C33.4968 102.642 41.9075 94.1906 41.9075 83.765C41.9075 73.3393 33.4968 64.8877 23.1217 64.8877C12.7466 64.8877 4.33594 73.3393 4.33594 83.765C4.33594 94.1906 12.7466 102.642 23.1217 102.642Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0663 69.3674L23.0586 83.666L23.5027 83.8544L29.5104 69.5558C29.562 69.433 29.5044 69.2913 29.3818 69.2393C29.2592 69.1872 29.1179 69.2446 29.0663 69.3674Z",
    fill: "#6020D4",
    stroke: "#6020D4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0072 91.5604L22.9902 84.044L23.5443 83.7656L27.6998 91.1428L27.0072 91.5604Z",
    fill: "url(#paint0_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4919 83.8166L23.0684 84.0479L26.9675 91.2581C27.0309 91.3753 27.1771 91.4185 27.294 91.3547C27.411 91.2908 27.4544 91.144 27.391 91.0268L23.4919 83.8166Z",
    fill: "#6020D4",
    stroke: "#6020D4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1218 84.5736C23.5655 84.5736 23.9252 84.2122 23.9252 83.7663C23.9252 83.3204 23.5655 82.959 23.1218 82.959C22.6781 82.959 22.3184 83.3204 22.3184 83.7663C22.3184 84.2122 22.6781 84.5736 23.1218 84.5736Z",
    fill: "#6F39D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 906.559,
    y1: 4328.02,
    x2: 906.559,
    y2: 3891.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.5504fdb1a1b98a460aa96f6fe8200dd3.svg";
export { ForwardRef as ReactComponent };